import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=5b333c07&scoped=true&"
import script from "./ProductSelect.vue?vue&type=script&lang=js&"
export * from "./ProductSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelect.vue?vue&type=style&index=0&id=5b333c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b333c07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItemContent,VListItemTitle,VSelect})
